import { Region } from 'src/app/utils/regions';

export function mapDataVersionToRegion(dataVersion: string | null) {
  let region: Region | string = 'No Region';
  if (dataVersion === null) {
    return region;
  }
  switch (dataVersion) {
    case 'Current':
    case 'PCM_NA':
    case 'PCM_NA_14Q2':
    case 'PCM_NA_13Q2':
      region = 'North America';
      break;
    case 'PCM_EU':
      region = 'Europe';
      break;
    case 'PCM_AF':
      region = 'Africa';
      break;
    case 'PCM_AS':
      region = 'Asia';
      break;
    case 'PCM_OC':
      region = 'Oceania';
      break;
    case 'PCM_SA':
      region = 'South America';
      break;
    case 'PCM_ME':
      region = 'Middle East';
      break;
  }
  return region;
}
